import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
    children: ReactNode;
}
interface State {
    error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
    state: State = { error: null };

    static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error("KRITHI.OS crashed:", error, info.componentStack);
    }

    render() {
        if (this.state.error) {
            return (
                <div className="grid min-h-screen place-items-center bg-cream p-6 font-mono text-ink">
                    <div className="max-w-md rounded-2xl border-2 border-ink bg-paper p-6 shadow-[6px_6px_0_#1C1917]">
                        <p className="text-xs text-inkfaint">krithi.os v7.0 — unexpected shutdown</p>
                        <h1 className="mt-2 font-display text-2xl font-extrabold">Something crashed.</h1>
                        <p className="mt-2 text-sm text-inksoft">
                            Even this OS has bugs. Reload to reboot — your progress is saved.
                        </p>
                        <button
                            data-testid="error-reload-button"
                            className="btn btn-blue mt-4"
                            onClick={() => window.location.reload()}
                        >
                            Reboot krithi.os
                        </button>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
